module.exports = __webpack_public_path__ + "img/font_3.43a2897d.webp";